import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useEffect, useRef } from 'react';
import { useMappingService, useTrackingService } from './serviceHooks';

export const useCategoryViewTracker = (listId: string | undefined, request: IRequestContext) => {
    const lastTrackedListRef = useRef<string | undefined>();

    const relewiseTrackingService = useTrackingService(request);
    const relewiseMappingService = useMappingService(request);

    useEffect(() => {
        if (!listId || lastTrackedListRef.current === listId) {
            return;
        }

        relewiseTrackingService.trackCategoryView(relewiseMappingService.prefixId(listId));
        lastTrackedListRef.current = listId;
    }, [listId, relewiseTrackingService, relewiseMappingService]);
};
